import { render, staticRenderFns } from "./GridCheckbox.vue?vue&type=template&id=570f10c4&scoped=true"
import script from "./GridCheckbox.vue?vue&type=script&lang=js"
export * from "./GridCheckbox.vue?vue&type=script&lang=js"
import style0 from "./GridCheckbox.vue?vue&type=style&index=0&id=570f10c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f10c4",
  null
  
)

export default component.exports